module.exports = {
      id: "about-usage",
      viewBox: "0 0 11.427 15",
      url: "img/" + "sprite.svg#about-usage",
      toString: function () {
        return this.url;
      }
    }